// TSS vite/04 §"Endpoint paths". baseURL ya incluye /api/v1.
// Capa 5 financiera (admin-billing-*.md): catálogo (managements/costs + composición),
// tarifas versionadas y liquidaciones. Fase 1 = catálogo.

export const billingPaths = {
    // catálogo
    managements: ()        => 'admin/billing/managements',
    management:  (id)      => `admin/billing/managements/${id}`,
    lines:       (id)      => `admin/billing/managements/${id}/lines`,
    line:        (id, lId) => `admin/billing/managements/${id}/lines/${lId}`,
    costs:       ()        => 'admin/billing/costs',
    cost:        (id)      => `admin/billing/costs/${id}`,
    // tarifas versionadas
    tariffs:     ()        => 'admin/billing/tariffs',
    tariff:      (id)      => `admin/billing/tariffs/${id}`,
    // estadías de manejo (por vaca)
    stays:       ()        => 'admin/billing/stays',
    stay:        (id)      => `admin/billing/stays/${id}`,
    stayMove:    ()        => 'admin/billing/stays/move',
    stayClose:   ()        => 'admin/billing/stays/close',
    // liquidaciones
    batches:      ()       => 'admin/billing/batches',
    batch:        (id)     => `admin/billing/batches/${id}`,
    batchPost:    (id)     => `admin/billing/batches/${id}/post`,
    batchLedger:  (id)     => `admin/billing/batches/${id}/ledger`,
    batchReverse: (id)     => `admin/billing/batches/${id}/reverse`,
    // drill-down vaca-mes (Q-118): pensión + ajustes + subtotal neto
    cowLiquidations: ()    => 'admin/billing/liquidations',
    // ajustes / exchanges (cargos/haberes por vaca-período)
    exchanges:    ()       => 'admin/billing/exchanges',
    exchange:     (id)     => `admin/billing/exchanges/${id}`,
    // pagos + notas-crédito + estado de cuenta (ledger)
    payments:     ()       => 'admin/billing/payments',
    creditNotes:  ()       => 'admin/billing/credit-notes',
    account:      (client) => `admin/billing/accounts/${client}`,
};
